module.exports = __webpack_public_path__ + "img/401.43968b14.png";